import { styled } from "styled-components";

export const FooterMain = styled.p`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const FooterName = styled.a`
  text-decoration: underline;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
`;
